import {uniqueId} from 'lodash'
import {EMAIL_STATUSES} from '@/constants/emailStatus'

const columns = [
  {
    title: 'Date',
    prop: 'timeOfGetMessage',
    type: 'date',
    width: 'minmax(100px, 1fr)'
  },
  {
    title: 'User',
    prop: 'user.username',
    width: 'minmax(150px, 1.5fr)',
    capitalize: true
  },
  {
    title: 'Email from',
    prop: 'deliveryFromValue',
    width: 'minmax(150px, 1.5fr)'
  },
  {
    title: 'Received at',
    prop: 'timeOfGetMessage',
    type: 'date',
    formatDate: 'hh:mm:ss a',
    width: 'minmax(100px, 1fr)'
  },
  {
    title: 'Replied at',
    prop: 'timeOfReplyMessage',
    type: 'date',
    formatDate: 'hh:mm:ss a',
    width: 'minmax(100px, 1fr)'
  },
  {
    title: 'Response time',
    prop: 'durationReplyMessage',
    type: 'date',
    dateType: 'diff',
    datesProp: {
      start: 'timeOfGetMessage',
      end: 'timeOfReplyMessage'
    },
    iconDate: (val) => {
      const min = val / 60000
      if (min <= 15) {
        return {
          icon: 'checked',
          style: 'green'
        }
      } else if (min > 300) {
        return {
          icon: 'brick',
          style: 'red'
        }
      }
    },
    filterBy: EMAIL_STATUSES,
    filterProp: 'status',
    pointer: true,
    width: 'minmax(150px, 1fr)'
  }
]

const prefix = 'email_stats_column_'
const emailStatsTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default emailStatsTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/emailStatsTable.js